import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppSessionService } from "../app-session/app-session.service";

@Injectable({
    providedIn: 'root'
  })
  export class FccService {

    constructor(private http: HttpClient, private appSession: AppSessionService) { }

    createFcc(fcc): Observable<any> {
        const headers = new HttpHeaders({
          'Content-type': 'application/json'
        });
    
        const data = JSON.stringify(fcc);
        const url = `${this.appSession.baseUrl + '/api/v1/devices/fcc'}`;
        return this.http.post(url, data, { headers });
      }

      
  updateFcc(fcc): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    const data = JSON.stringify(fcc);
    const url = `${this.appSession.baseUrl + '/api/v1/devices/fcc'}/${fcc?.code}`;
    return this.http.put(url, data, { headers });

  }
  }